export default function YoutubeIcon() {
  return (
<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="20" cy="20" r="20" fill="white" fill-opacity="0.87"/>
<path d="M20 12.3008C10.172 12.3008 10 13.1748 10 20.0007C10 26.8266 10.172 27.7005 20 27.7005C29.828 27.7005 30 26.8266 30 20.0007C30 13.1748 29.828 12.3008 20 12.3008ZM23.205 20.3347L18.715 22.4306C18.322 22.6126 18 22.4086 18 21.9746V18.0267C18 17.5937 18.322 17.3887 18.715 17.5707L23.205 19.6667C23.598 19.8507 23.598 20.1507 23.205 20.3347Z" fill="#333333"/>
</svg>
  );
}
